import { render, staticRenderFns } from "./companyCreate.vue?vue&type=template&id=6e196cce&scoped=true&"
import script from "./companyCreate.vue?vue&type=script&lang=ts&"
export * from "./companyCreate.vue?vue&type=script&lang=ts&"
import style0 from "./companyCreate.vue?vue&type=style&index=0&id=6e196cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e196cce",
  null
  
)

export default component.exports